export const MONTHLYEVOLUTIONBYSEVERITY = 'monthly_evolution_by_severity';
export const MONTHLYEVOLUTIONBYSTATUS = 'monthly_evolution_by_status';
export const TOPTENMOSTAFFECTED = 'top_ten_most_affected_hosts';
export const TOPTENMOSTREPEATED = 'top_ten_most_repeated_vulns';
export const VULNSPERHOSTS = 'vulnerabilities_per_host';
export const VULNSPERSEVERITY = 'vulnerabilities_per_severity';
export const VULNSPERSTATUS = 'vulnerabilities_per_status';
